import "./portal.scss";

import { useEffect, useState } from "react";

import AlertMessage from "../lessons/trial/AlertMessage";
import Icon from "../../components/Icon";
import { NavLink } from "react-router-dom";
import { QueryClient } from "@tanstack/react-query";
import SignUpLogo from "../../components/SignUpLogo";
import { useAuth } from "../../context";
import { useNavigate } from "react-router-dom";
import { useRole } from "../../context/RoleContext";

interface NavItem {
  name: string;
  link: string;
}

export default function Layout({ children, color }: any) {
  const queryClient = new QueryClient();

  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const { user, logout } = useAuth();
  const { role } = useRole();

  const navigate = useNavigate();

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const handleLogout = () => {
    logout(); // Call the logout function from context
    navigate("/login"); // Redirect to login page after logout
  };

  const navigation: NavItem[] = [
    {
      name: "Home",
      link: "/home",
    },
    {
      name: "Lessons",
      link: "/lessons",
    },
    {
      name: "Schedule",
      link: "/schedule",
    },
    {
      name: "Availability",
      link: "/availability",
    },
    {
      name: "Message",
      link: "/message",
    },
    {
      name: "Profile",
      link: "/profile",
    },
  ];

  const filters = navigation.filter((item) => {
    return item?.name !== "Lessons" && item?.name !== "Message";
  });

  return (
    <div className="dashboard">
      <button className="icon-button ham" onClick={toggleSidebar}>
        <Icon name={"menu"} />
      </button>

      <aside className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
        <div className="sidebar-header">
          {isSidebarOpen ? (
            <button className="icon-button close" onClick={toggleSidebar}>
              <Icon name={"close"} />
            </button>
          ) : (
            <div className="sideBar-Header-box">
              <SignUpLogo />
              <h3>Pluritongues</h3>
            </div>
          )}
        </div>
        <nav className="sidebar-nav">
          <ul>
            {role?.toLocaleLowerCase() == "teacher" ? (
              <>
                {navigation?.map((navItem, index) => {
                  return (
                    <li key={index}>
                      <NavLink
                        to={navItem.link}
                        className={({ isActive }) =>
                          isActive ? "active" : "inactive"
                        }
                      >
                        {navItem.name === "Home" ? (
                          <Icon
                            name={"Home"}
                            width={25}
                            height={25}
                            className="icons"
                          />
                        ) : navItem.name === "Lessons" ? (
                          <Icon
                            name={"Lessons"}
                            width={30}
                            height={30}
                            className="icons"
                          />
                        ) : navItem.name === "Schedule" ? (
                          <Icon
                            name={"Schedule"}
                            width={25}
                            height={25}
                            className="icons"
                          />
                        ) : navItem.name === "Availability" ? (
                          <Icon
                            name={"Availability"}
                            width={25}
                            height={25}
                            className="icons"
                          />
                        ) : navItem.name === "Message" ? (
                          <Icon
                            name={"Message"}
                            width={25}
                            height={25}
                            className="icons"
                          />
                        ) : (
                          navItem.name === "Profile" && (
                            <Icon
                              name={"Profile"}
                              width={30}
                              height={30}
                              className="icons"
                            />
                          )
                        )}
                        {navItem.name}
                      </NavLink>
                    </li>
                  );
                })}
              </>
            ) : (
              role?.toLocaleLowerCase() === "partner" && (
                <>
                  {filters?.map((nav, index) => (
                    <li key={index}>
                      <NavLink
                        to={nav.link}
                        className={({ isActive }) =>
                          isActive ? "active" : "inactive"
                        }
                      >
                        {nav.name === "Home" ? (
                          <Icon
                            name={"Home"}
                            width={25}
                            height={25}
                            className="icons"
                          />
                        ) : nav.name === "Lessons" ? (
                          <Icon
                            name={"Lessons"}
                            width={30}
                            height={30}
                            className="icons"
                          />
                        ) : nav.name === "Schedule" ? (
                          <Icon
                            name={"Schedule"}
                            width={25}
                            height={25}
                            className="icons"
                          />
                        ) : nav.name === "Availability" ? (
                          <Icon
                            name={"Availability"}
                            width={25}
                            height={25}
                            className="icons"
                          />
                        ) : nav.name === "Message" ? (
                          <Icon
                            name={"Message"}
                            width={25}
                            height={25}
                            className="icons"
                          />
                        ) : (
                          nav.name === "Profile" && (
                            <Icon
                              name={"Profile"}
                              width={30}
                              height={30}
                              className="icons"
                            />
                          )
                        )}
                        {nav.name}
                      </NavLink>
                    </li>
                  ))}
                </>
              )
            )}
          </ul>

          <div
            className="logout-btn"
            typeof="button"
            onClick={handleLogout}
            data-test="logout"
          >
            <Icon name="Logout" width={30} height={30} className="out" />
            Logout
          </div>
        </nav>
      </aside>

      <div className={`main-content`}>
        <section
          style={{ backgroundColor: color || "white", marginTop: 30 }}
          className="dashboard-content"
        >
          {/* {!isTrialLessonCreated && <AlertMessage title="Action Required" />} */}
          {children}
        </section>
      </div>
    </div>
  );
}
